import { recordReferralLinkOpened } from '@api/referralInvite';
import { withCrossTabLock } from '@utils/withCrossTabLock';

const RECORDED_KEY = 'referral-links-opened';

const readRecorded = (): string[] => {
  try {
    const stored = JSON.parse(localStorage.getItem(RECORDED_KEY) ?? '[]');
    return Array.isArray(stored) ? stored : [];
  } catch {
    return [];
  }
};

const writeRecorded = (codes: string[]) => {
  try {
    localStorage.setItem(RECORDED_KEY, JSON.stringify(codes));
  } catch {
    // Sem storage, cada abertura grava.
  }
};

const claim = (referrerCode: string): boolean => {
  if (readRecorded().includes(referrerCode)) return false;

  writeRecorded([...readRecorded(), referrerCode]);
  return true;
};

const release = (referrerCode: string) =>
  writeRecorded(readRecorded().filter((code) => code !== referrerCode));

const withLock = <T>(fn: () => T) => withCrossTabLock(RECORDED_KEY, fn);

// Uma abertura por código neste navegador. A marca sai se o envio falhar.
export const trackReferralLinkOpen = async (referrerCode: string) => {
  if (!(await withLock(() => claim(referrerCode)))) return;

  try {
    await recordReferralLinkOpened(referrerCode);
  } catch (error) {
    await withLock(() => release(referrerCode));
    throw error;
  }
};
